import PublicSuitabilityTool from '../components/public-suitability-tool/PublicSuitabilityTool';
import ErrorBoundaryView, { NotFoundView } from '../views/ErrorBoundaryView';

const MarketingRoutes = {
  errorElement: <ErrorBoundaryView />,
  path: 'marketing',
  children: [
    {
      path: 'public-suitability-tool',
      element: <PublicSuitabilityTool />,
    },
    {
      path: '*',
      element: <NotFoundView />,
    },
  ],
};

export default MarketingRoutes;
